import type { IconData } from '@stacksjs/iconify-core'

export const bellF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M18 17H0a8.98 8.98 0 0 1 3-6.708V6a6 6 0 1 1 12 0v4.292A8.98 8.98 0 0 1 18 17M6.17 18h5.66a3.001 3.001 0 0 1-5.66 0\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default bellF
